import ServiceLayout from "./ServiceLayout";
import { Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

const VerticalGarden = () => {
  return (
    <>
      <Helmet>
        <title>Vertical Garden | KRM Landscape</title>
        <meta
          name="description"
          content="Transform your walls with KRM Landscape's Vertical Garden service, creating stunning green spaces for homes and commercial buildings."
        />
        <meta
          name="keywords"
          content="Vertical Garden, Living Wall, Green Wall, KRM Landscape, Indoor Vertical Garden, Outdoor Vertical Garden"
        />
      </Helmet>
      <ServiceLayout title="Vertical Garden">

        {/* Hero Image */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Box
            component="img"
            src="/images/verticalgarden.webp"
            alt="Vertical Garden by KRM Landscape"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxHeight: "400px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </Box>

        <Typography paragraph>
          Our Vertical Garden service transforms blank walls into living,
          breathing green spaces that enhance aesthetics and improve air quality.
          Ideal for homes, offices, restaurants, and commercial buildings,
          vertical gardens add a striking natural element even in limited spaces.
        </Typography>

        <Typography paragraph>
          We design customized vertical gardens based on wall structure, lighting
          conditions, and plant suitability. From natural plant systems to
          low-maintenance modular setups, each design balances beauty,
          functionality, and sustainability.
        </Typography>

        <Typography paragraph>
          Our service includes structure installation, plant selection, irrigation
          integration, and aesthetic arrangement. We ensure proper plant growth,
          drainage, and long-term stability for a healthy vertical ecosystem.
        </Typography>

        <Typography paragraph>
          With KRM Landscape, vertical gardens become more than decor, they act as
          natural cooling systems and visual focal points, bringing life and
          freshness to your surroundings.
        </Typography>

      </ServiceLayout>
    </>
  );
};

export default VerticalGarden;
